// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-D":"D_vanlife-roadtrips-D__UWzZo"};